import { render, staticRenderFns } from "./ProductQuerySummary.vue?vue&type=template&id=de96522e&scoped=true&"
import script from "./ProductQuerySummary.vue?vue&type=script&lang=js&"
export * from "./ProductQuerySummary.vue?vue&type=script&lang=js&"
import style0 from "./ProductQuerySummary.vue?vue&type=style&index=0&id=de96522e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de96522e",
  null
  
)

export default component.exports